import React, {useState, useEffect} from "react";
import {Button, Modal, notification, InputNumber, Typography} from "antd";
import '../modals.css';
import {deliveriesService} from "../../../services";
import i18n from "../../../i18n";

const {Text} = Typography;

export default function ModalEditDelivery({
                                            isShow, delivery, onCloseModal, setNeedUpdate
                                          }) {
  const [distance, setDistance] = useState(delivery.DeliveryDistance || 0);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (delivery) {
      setDistance(delivery.DeliveryDistance || 0);
    }
  }, [delivery]);

  const onSave = () => {
    setIsDisabled(true);
    deliveriesService.editDelivery(delivery.Id, distance)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.editDelivery'), description: response.message,
        });
        onCloseModal();
        setNeedUpdate(true);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.editDelivery'), description: err,
        });
      })
      .finally(() => {
        setIsDisabled(false);
      })
  }

  return (
    <Modal
      title={<div>{i18n.t('modals.modalEditDelivery.title')} № {delivery && delivery.NumberDelivery}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
      }}
      forceRender={true}
      footer={
        <Button
          htmlType="submit"
          key="submit"
          type="primary"
          style={{width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'}}
          onClick={() => onSave()}
          disabled={isDisabled}
        >
          {i18n.t('main.buttons.save')}
        </Button>
      }
    >
      <div style={{marginBottom: "34px"}}>
        <Text strong style={{fontSize: "20px"}}>{i18n.t('modals.modalEditDelivery.fields.distance')}</Text>
        <InputNumber
          style={{width: "100%", marginTop: "10px"}}
          value={distance}
          onChange={(value) => setDistance(value)}
          min={0}
          size="large"
        />
      </div>
    </Modal>
  );
}